import { render, staticRenderFns } from "./NewMessageTemplatePreview.vue?vue&type=template&id=072b4801&scoped=true"
import script from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"
export * from "./NewMessageTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./NewMessageTemplatePreview.vue?vue&type=style&index=0&id=072b4801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b4801",
  null
  
)

export default component.exports